"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$NotificationRequestDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$NotificationRequestDto = {
    properties: {
        devices: {
            type: 'array',
            contains: {
                type: 'DeviceRequestDto',
            },
            isRequired: true,
        },
        body: {
            type: 'all-of',
            description: `Payload configuration`,
            contains: [{
                    type: 'NotificationBodyRequestDto',
                }],
            isRequired: true,
        },
        delay: {
            type: 'number',
            description: `Delay to send notification`,
        },
    },
};
